import { OpenAccountModalContent } from '../ui';
import { useAccountOpeningTimer } from '@/features/account-open/model/useAccountOpeningTimer';
import type { OpenAccountResponseDto } from '@/features/account-open/api/types';
import type { OpenAccountType } from '@/features/account-open/model/types';
import { useCallback } from 'react';
import type { AccountType } from '@/entities/account';
import { useModalStore } from '@/shared/lib';

const useAccountCreateModal = (type?: AccountType) => {
  const { showDialogComponent } = useModalStore();
  const { addPendingAccount } = useAccountOpeningTimer();

  const onSuccess = useCallback(
    (
      data: OpenAccountResponseDto,
      accountType: OpenAccountType,
      assetCode?: string,
      accountCode?: string
    ) => {
      const tradingAccountKey = data.tradingAccountKey;
      if (tradingAccountKey && data?.openingTimeout && data?.accountNumber) {
        addPendingAccount(
          String(tradingAccountKey),
          accountType,
          data.openingTimeout,
          assetCode,
          accountCode
        );
      }
    },
    [addPendingAccount]
  );

  const openCreateAccountModal = () => {
    showDialogComponent({
      component: <OpenAccountModalContent onSuccess={onSuccess} type={type} />,
      className: 'bg-secondary-bg',
    });
  };

  return {
    openCreateAccountModal,
  };
};

export { useAccountCreateModal };
